import React from "react";
import { useEditingMicrosite } from "../../contexts/EditingMicrositeContext";
import { Globe, X } from "lucide-react";

const BUSINESS_TYPE_COLORS = {
  bounce_house: "#f43f5e",
  foam_party:   "#0ea5e9",
  photo_booth:  "#d97706",
  general:      "#16a34a",
};

/**
 * Shown at the top of pages that support microsite filtering (Bookings, Catalog, Customers).
 * When a specific microsite is selected in the sidebar, this bar shows which site is active
 * and provides a "See All" toggle.
 */
export default function MicrositeFilterBar() {
  const { selectedMicrosite, isAllSites, selectMicrosite } = useEditingMicrosite();

  if (isAllSites || !selectedMicrosite) return null;

  const color = BUSINESS_TYPE_COLORS[selectedMicrosite.business_type] || "#6366f1";

  return (
    <div
      className="flex items-center gap-3 px-4 py-2.5 rounded-xl border text-sm mb-4"
      style={{ background: `${color}08`, borderColor: `${color}25` }}
      data-testid="microsite-filter-bar"
    >
      <Globe className="h-4 w-4 flex-shrink-0" style={{ color }} />
      <span className="font-medium" style={{ color }}>
        Viewing: {selectedMicrosite.name}
      </span>
      <span className="text-slate-400 text-xs">— showing data for this site only</span>
      <button
        className="ml-auto flex items-center gap-1 text-xs font-semibold text-slate-500 hover:text-slate-700 transition-colors px-2 py-1 rounded-lg hover:bg-white border border-transparent hover:border-slate-200"
        onClick={() => selectMicrosite("all")}
        data-testid="see-all-sites-btn"
      >
        <X className="h-3 w-3" /> See All
      </button>
    </div>
  );
}
